
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1i0s3_1d4cm_94",
  "header": "awsui_header_1i0s3_1d4cm_105",
  "content": "awsui_content_1i0s3_1d4cm_109",
  "error": "awsui_error_1i0s3_1d4cm_113",
  "footer": "awsui_footer_1i0s3_1d4cm_117",
  "actions-section": "awsui_actions-section_1i0s3_1d4cm_121",
  "secondary-actions": "awsui_secondary-actions_1i0s3_1d4cm_130",
  "actions": "awsui_actions_1i0s3_1d4cm_121"
};
  